import { clsx } from "clsx";

export default function IconChevronDown({ className }: { className?: string }) {
  return (
    <svg
      className={clsx("", className)}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9996 20.3535L16.7163 19.6618L22.7163 13.6618L21.283 12.2285L15.9996 17.5077L10.7163 12.2285L9.28298 13.6618L15.283 19.6618L15.9996 20.3535Z"
        fill="currentColor"
      />
    </svg>
  );
}
